import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consent-use-case-container',
  templateUrl: './consent-use-case-container.component.html',
  styleUrls: ['./consent-use-case-container.component.scss']
})
export class ConsentUseCaseContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
